export default "__VITE_ASSET__zctGfxwv__"